import { render, staticRenderFns } from "./LabTestModal.vue?vue&type=template&id=2c94d76e&"
import script from "./LabTestModal.vue?vue&type=script&lang=js&"
export * from "./LabTestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports